import Arch from './Arch';
import Photo from './Photo';
import SmartLink from './SmartLink';

function Chip({ pill }) {
  if (!pill) return null;
  return (
    <SmartLink className="chip" url={pill.link}>
      <span className="chip-art"><Photo src={pill.image} eager /></span>
      <span className="chip-text">
        <strong>{pill.title}</strong>
        {pill.text && <span>{pill.text}</span>}
      </span>
    </SmartLink>
  );
}

export default function Hero({ hero }) {
  return (
    <section id="top" className="hero" aria-label={`${hero.line1} ${hero.line2}`}>
      <div className="hero-tiles" aria-hidden="true" />
      <div className="wrap hero-grid">
        <div className="hero-copy">
          <h1 className="hero-title" aria-label={`${hero.line1} ${hero.line2}`}>
            <span aria-hidden="true">{hero.line1}</span>
            <span aria-hidden="true">{hero.line2}</span>
          </h1>
          <p className="hero-roster">{hero.tagline}</p>
          <div className="hero-actions">
            {hero.buttons.map((btn) => <SmartLink key={btn.label} className={`btn ${btn.style}`} url={btn.url}>{btn.label}</SmartLink>)}
          </div>
          <Chip pill={hero.pill} />
        </div>
        <div className="hero-art">
          <Arch src={hero.photo} tone="dark" eager alt={hero.alt} position={hero.focus} />
        </div>
      </div>
      <div className="frieze frieze--cobalt" aria-hidden="true" />
    </section>
  );
}
